import authHeader from "./auth-header";
import axiosInstance from "./instance";

class UserPermissionsService {
  getAPIUsers(maintainer) {
    return axiosInstance.get("/api_user", {
      params: { maintainer },
      headers: authHeader(),
    });
  }
  createAPIUser(data) {
    return axiosInstance.post("/api_user", data, {
      headers: authHeader(),
    });
  }
  updateAPIUser(data) {
    return axiosInstance.put("/api_user", data, {
      headers: authHeader(),
    });
  }
  getAPITables(maintainer) {
    return axiosInstance.get("/api_tables", {
      params: { maintainer },
      headers: authHeader(),
    });
  }
  createAPIUserPermissions(data) {
    return axiosInstance.post("/api_permissions", data, {
      headers: authHeader(),
    });
  }
  getAPIColumns(maintainer, table_name, imo) {
    return axiosInstance.get("/api_columns", {
      params: { maintainer, table_name, imo },
      headers: authHeader(),
    });
  }
  updateAPIUserPermissions(data) {
    return axiosInstance.put("/api_permissions", data, {
      headers: authHeader(),
    });
  }
  getAPIUserPermissions(params) {
    return axiosInstance.get("/api_permissions", {
      params,
      headers: authHeader(),
    });
  }
}

export default new UserPermissionsService();
